import { ZoneModel } from "./ZoneModel";

export default class LocationModel {
  id: string;
  active: boolean = true;
  address1?: string = "";
  address2?: string = "";
  city?: string = "";
  hideInFilters: boolean = false;
  lat?: number;
  lng?: number;
  shortTitle?: string = "";
  state?: string = "";
  title: string = "";
  zip?: string = "";
  zones: ZoneModel[] = [];

  constructor(data: LocationModel | {}) {
    Object.assign(this, data);
  }
}
